<template>
  <div id="app">
    <Header/>
    <Countries/>
    <Footer/>
  </div>
</template>

<script>
import Header from './components/Header';
import Countries from './components/Countries';
import Footer from './components/Footer';

export default {
  name: 'App',
  components: {
    Header,
    Countries,
    Footer,
  },
};
</script>

<style scoped>
@import './assets/css/style.css';

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  width: 100%;
  padding: 0;
  margin: 0;
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue